import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('faaNumberField');

    return {
        FAA_REGISTRATION_NUMBER_FIELD_LABEL: t('faaRegistrationNumberFieldLabel')
    };
};

export default useTranslation;
